import { useEffect } from 'react';
import { api } from '../../api';
import { useAccess } from '../../lib/access';
import { useApi } from '../../lib/useApi';
import { ADDON_PERMISSIONS, addonNavEntries, onAddonMenuChanged, type AddonNavEntry } from '../../nav/addonMenu';
import { useRetained } from '../Write';

const REFRESH_MS = 60_000;

/**
 * The running add-ons' menu entries the user may open ("Tiện ích" in the sidebar,
 * `nav/addonMenu.ts`): read every minute and as soon as an add-on is switched on or off in Cài
 * đặt › Module › Tiện ích. None for customer users, staff without an add-on permission, or while
 * the list cannot be loaded.
 */
export function useAddonNav(): AddonNavEntry[] {
  const access = useAccess();
  const allowed = !access.client && access.has(ADDON_PERMISSIONS);
  const menu = useApi((signal) => (allowed ? api.getAddonMenu({ signal }) : Promise.resolve({ items: [] })), [allowed]);
  const { reload } = menu;
  useEffect(() => {
    if (!allowed) return undefined;
    const id = window.setInterval(reload, REFRESH_MS);
    const stop = onAddonMenuChanged(reload);
    return () => {
      window.clearInterval(id);
      stop();
    };
  }, [allowed, reload]);
  const items = useRetained(menu.data)?.items ?? [];
  return allowed ? addonNavEntries(items, access.has) : [];
}
